import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getConfig } from 'src/utilities/config';
import { isSeamlessRoute } from 'src/utilities/route-utils';

// TODO (mbeade) make this options props for reuse
export default function Header(): JSX.Element {
  const {
    site: { description, grubhubFavicon, seamlessFavicon },
  } = getConfig();

  let favicon = grubhubFavicon;

  if (isSeamlessRoute()) {
    favicon = seamlessFavicon;
  }

  return (
    <Helmet defer={false}>
      <meta name="description" content={description} />
      <link rel="icon" href={favicon} />
    </Helmet>
  );
}
